import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

enum HttpContextRoutes {
  // File upload
  UploadFile,
  SharedDownloadFile,
  DownloadZipArchive,
}

export const HttpSharedFileContext = createRouteContextObject(
  HttpContextBase.SharedFile,
  HttpContextRoutes
);
